import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=755c51fe&scoped=true"
import script from "./KeyValue.vue?vue&type=script&lang=js"
export * from "./KeyValue.vue?vue&type=script&lang=js"
import style0 from "./KeyValue.vue?vue&type=style&index=0&id=755c51fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c51fe",
  null
  
)

export default component.exports